module.exports = __webpack_public_path__ + "img/resources_img.99be88e0.jpg";